export const MAX_VISIBLE_LINKED_PAGES = 8;
